import { render, staticRenderFns } from "./ManualInvoiceModal.vue?vue&type=template&id=5d1087b3&scoped=true"
import script from "./ManualInvoiceModal.vue?vue&type=script&lang=js"
export * from "./ManualInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./ManualInvoiceModal.vue?vue&type=style&index=0&id=5d1087b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1087b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCombobox,VForm,VTextarea})
